<template lang="pug">
el-container.main 
    .main-content
        .statistics-logo
            //- img(alt="SatMetaInfo logo" src="img/index.png")

            vue-typed-js(
                :strings="['starlink', 'oneweb', 'gaofeng', 'sentinel', 'beidou']",
                loop,
                :smartBackspace="true",
                :typeSpeed="120",
                :backSpeed="50",
                :backDelay="500"
            )
                h1 Search Interested Satellite
                    br
                    span.typing
                    br
                    el-button(
                        size="small",
                        icon="el-icon-s-promotion",
                        @click.native="jumpTo('/satellite')"
                    ) Explore
        .statistics-block
            el-card.info-card(shadow="hover", @click.native="jumpTo('/satellite')")
                img(src="img/icons/satellite.png")
                h2 
                    countTo(
                        :startVal="0",
                        :endVal="this.metric.satinfo.satellite.total",
                        :duration="3000",
                        suffix=" 颗卫星"
                    )
            el-card.info-card(shadow="hover", @click.native="jumpTo('/instrument')")
                img(src="img/icons/instrument.png")
                h2
                    countTo(
                        :startVal="0",
                        :endVal="this.metric.satinfo.instrument.total",
                        :duration="3000",
                        suffix=" 个载荷"
                    )
            el-card.info-card(shadow="hover", @click.native="jumpTo('/launch')")
                img(src="img/icons/Rocket-Launch.svg")
                h2
                    countTo(
                        :startVal="0",
                        :endVal="this.metric.missions.launch.total",
                        :duration="3000",
                        suffix=" 次发射"
                    )
    el-footer 
        p Copyrigh©2020 上海蔚星数据科技 All rights reserved
        p 沪ICP备16011377号
</template>

<script>
import { getSatinfoStat, getMissionsStat } from "@/services";
import countTo from "vue-count-to";
export default {
    name: "home",
    components: { countTo },
    data() {
        return {
            loading: false,
            metric: {
                satinfo: { satellite: { total: 0 }, instrument: { total: 0 } },
                missions: { launch: { total: 0 } }
            },
        };
    },
    methods: {
        async fetch() {
            this.loading = true;
            const res1 = await getSatinfoStat();
            const res2 = await getMissionsStat();
            Object.assign(this.metric, { satinfo: res1.data }, { missions: res2.data })
            this.loading = false;
        },
        jumpTo(url) {
            this.$router.push({ path: url });
        },
    },
    mounted() {
        this.fetch();
    },
};
</script>
<style lang="stylus" scoped>
.main {
  max-width: 100%;
}

.main-content {
  display: block;
  padding: 0;
}

.statistics-logo {
  overflow: hidden;
  height: 60vh;
  background: url('/img/index.png') no-repeat center center;
  background-size: cover;

  h1 {
    position: absolute;
    bottom: 60%;
    left: 8%;
    color: floralwhite;
    font-size: xxx-large;
    font-style: italic;

    span {
      font-size: xx-large;
    }
  }
}

.statistics-block {
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.el-card {
  border-radius: 15px;
}

.info-card {
  margin: 20px 10px;
  width: 480px;
  height: 300px;
  cursor: pointer;

  h2 {
    padding: 15px;
  }
}

.el-footer {
  background: #435B71;
  color: #fff;
  text-align: center;
  font-size: small;

  p {
    padding-top: 10px;
  }
}

@media only screen and (max-width: 540px) {
  .statistics-logo {
    h1 {
      bottom: 35%;
    }
  }

  .statistics-block {
    flex-direction: column;
    text-align: center;
    width: -webkit-fill-available;
  }

  .info-card {
    margin: 5px;
    width: -webkit-fill-available;

    h2 {
      padding: 15px;
    }
  }
}

.el-card__body {
  text-align: center;
}
</style>
